import React , { useContext} from "react";
import {NavLink} from 'react-router-dom'
import effect3 from "../../card/effect3.json";
import img1 from "../../view/HD-Wallpapers.jpg";
import { BackIndex } from '../../context/BackIndex'
import "./CartStyle.css";

export function Cart() {
  window.scrollTo(0,0);
  function selectImg(e) { if (e === "NaN") { return img1 } else { return e } }

  const  { setIndex } = useContext(BackIndex)
  function name(x) {
    setIndex(x)
  }
    
  return (
    <div id="container_cart" >
      {effect3.map((e, index) => {
        return (
          <div className="primer" key={index} style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
            <section className="primer_seccion">
              <div className="total_tarjeta">
                <h1 className="total_superTitle">{e.title[1]}</h1>
                <br />
              </div>
              <div className="total_vista">
                <img src={ selectImg(e.img[0]) } alt="Foto" />
                <br /><br />
              </div>
              <div className="total_cuerpo">
                <h4 className="Total_title">{e.lasttitle[1]}</h4>
                <p className="Total_parrafo">{e.epigraph[1]}</p>
              </div>
              <NavLink to= {`/Super/${e.slug}`} onClick={() => { name(`${index+1}`); }} id="navegador" lang="es" >Ve a cualquier parte</NavLink>
            </section>
          </div>
        );
      })}
    </div>
  );
}


